import React from "react";
import "./Form.css";
import rybka from "../imgs/rybka.png";
import { Link } from "react-router-dom";
export default function Form() {
  return (
    <div className="form" id="registrace">
      ´
      <div className="insideform">
        <img src={rybka} style={{ width: "150px", margin: "0 auto" }} alt="" />
        <h1 className="ryba">RYBA SMRDÍ OD HLAVY 2021</h1>
        <h2>POZVÁNKA</h2>
        <p style={{ marginBottom: "2rem" }}>
          aneb poděkování posluchačům, absolventům, partnerům a všem, které máme
          rádi na společné oslavě
        </p>
        <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
          <iframe
            src="https://player.vimeo.com/video/580451040?badge=0&autopause=0&player_id=0&app_id=58479"
            frameBorder={0}
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
            title="Pozv&aacute;nka na konferenci"
          />
        </div>

        <h3>24.9. 17:30, Hotel Passage , Brno</h3>
        <form
          method="post"
          target="_self"
          action="https://app.smartemailing.cz/public/web-forms-v2/display-form/136531-x2p7uweo2vxd7z5xyei5v991p2siscywg4g9j5wcl18scjn09iif8ndbgkn4ll7iyhggwmrxc5nbwikrxdygfz9sspigbd9qvxr9"
          id="se20-webform-136531-x2p7uweo2vxd7z5xyei5v991p2siscywg4g9j5wcl18scjn09iif8ndbgkn4ll7iyhggwmrxc5nbwikrxdygfz9sspigbd9qvxr9"
        >
          <ul>
            <li>
              <label htmlFor="frm-webFormHtmlRenderer-webFormForm-fields-df_name">
                Křestní jméno
              </label>
              <input
                type="text"
                name="fields[df_name]"
                id="frm-webFormHtmlRenderer-webFormForm-fields-df_name"
                required
              />
            </li>
            <li>
              <label htmlFor="frm-webFormHtmlRenderer-webFormForm-fields-df_surname">
                Příjmení
              </label>
              <input
                type="text"
                name="fields[df_surname]"
                id="frm-webFormHtmlRenderer-webFormForm-fields-df_surname"
                required
              />
            </li>
            <li>
              <label htmlFor="frm-webFormHtmlRenderer-webFormForm-fields-df_emailaddress">
                E-mailová adresa
              </label>
              <input
                type="text"
                name="fields[df_emailaddress]"
                data-emailaddress={1}
                id="frm-webFormHtmlRenderer-webFormForm-fields-df_emailaddress"
                required
              />
            </li>
            <li>
              <label htmlFor="frm-webFormHtmlRenderer-webFormForm-fields-df_phone">
                Telefon
              </label>
              <input
                type="text"
                name="fields[df_phone]"
                id="frm-webFormHtmlRenderer-webFormForm-fields-df_phone"
                required
              />
            </li>
            <li>
              <label htmlFor="frm-webFormHtmlRenderer-webFormForm-fields-df_company">
                Společnost (bude uvedeno na visačce)
              </label>
              <input
                type="text"
                name="fields[df_company]"
                id="frm-webFormHtmlRenderer-webFormForm-fields-df_company"
                required
              />
            </li>
          </ul>
          <input
            type="submit"
            name="_submit"
            defaultValue="Přijímám pozvánku"
          />
          <input
            type="hidden"
            name="referrer"
            id="se-ref-field-id"
            defaultValue
          />
          <input
            type="hidden"
            name="sessionid"
            id="se-sessionid-field"
            defaultValue
          />
          <input
            type="hidden"
            name="sessionUid"
            id="se-sessionUid-field"
            defaultValue
          />
          <input
            type="hidden"
            name="_do"
            defaultValue="webFormHtmlRenderer-webFormForm-submit"
          />
        </form>

        <p>
          Registrací souhlasíte se{" "}
          <a href="https://psychologieprokazdeho.cz/ochrana-osobnich-udaju/">
            zpracováním osobních údajů
          </a>{" "}
          a{" "}
          <Link to="/podminky-akce">
            Všeobecné podmínky účasti na konferenci
          </Link>{" "}
        </p>
        <p>
          Pokud jste tuto pozvánku obdrželi omylem, ignorujte ji. Všechny hosty
          budeme kontrolovat, zda-li je na seznamu hostů. Děkujeme za pochopení.
        </p>
      </div>
    </div>
  );
}
